import Pusher from 'pusher-js'

export default {
  setup() {
    this.pusher = new Pusher(process.env.VUE_APP_PUSHER_KEY.replace(/"/g, ''), {
      cluster: process.env.VUE_APP_PUSHER_CLUSTER.replace(/"/g, ''),
      encrypted: process.env.VUE_APP_PUSHER_ENCRYPTED.replace(/"/g, ''),
    })

    Pusher.logToConsole = process.env.VUE_APP_PUSHER_LOG_CONSOLE.replace(/"/g, '') === 'true'
  },

  setChannel(channelName) {
    this.channel = this.pusher.subscribe(channelName)
  },
}
